import { createRootRoute, Outlet, useLocation } from "@tanstack/react-router";

import AuthLoadingScreen from "../components/AuthLoadingScreen";
import CriticalBugAlarm from "../components/CriticalBugAlarm";
import DevBoardMentionNotifications from "../components/DevBoardMentionNotifications";
import NotificationToaster from "../components/NotificationToaster";
import ReportCommentNotifications from "../components/ReportCommentNotifications";
import { AuthProvider, useAuth } from "../context/AuthContext";
import { DashboardLanguageProvider } from "../context/DashboardLanguageContext";
import { ScopeProvider } from "../context/ScopeContext";

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <DashboardLanguageProvider>
      <AuthProvider>
        <ScopeProvider>
          <RootChrome />
        </ScopeProvider>
      </AuthProvider>
    </DashboardLanguageProvider>
  );
}

function RootChrome() {
  const location = useLocation();
  const auth = useAuth();
  const isLoading = auth.isLoading === true;

  const isPublicPortalRoute = location.pathname.startsWith("/portal/");
  const isChatbotPreviewRoute = location.pathname === "/chatbot/preview";
  // The office TV is unattended: toasts, alarms and mention popups have nobody
  // to reach there, and a sound alarm in an empty room is just noise.
  const isTvRoute = location.pathname === "/tv";

  if (isLoading && location.pathname !== "/auth/callback" && !isPublicPortalRoute) {
    return (
      <AuthLoadingScreen ariaLabel="Checking sign-in status" message="Checking sign-in status..." />
    );
  }

  return (
    <>
      {!isChatbotPreviewRoute && !isTvRoute && (
        <>
          <NotificationToaster />
          <CriticalBugAlarm />
          <ReportCommentNotifications />
          <DevBoardMentionNotifications />
        </>
      )}
      <Outlet />
    </>
  );
}
